import { __rest } from "tslib";
import { Button, DatePicker, PageHeader, Popover, Select, Tabs, Tooltip } from 'antd';
import { ProductTagEnum, } from 'api';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import locale from 'antd/es/date-picker/locale/zh_CN';
import classNames from 'classnames';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import Icon from '@ant-design/icons/lib/components/Icon';
import { useResizeDetector } from 'react-resize-detector';
import { MediaIcon, MediaWhiteIcon } from '@web-common/components/UI/Icons/icons';
import { getMeetingRoomAvailabelList, getMeetingRoomList, getMeetingRoomSearchCondition } from '../../service';
import TimeLinePicker from '../TimeLinePicker/TimeLinePicker';
import { TimeLinePickerGroup } from '../TimeLinePicker/TimeLinePickerGroup';
import styles from './meeting_room_form.module.scss';
import commonStyles from './createbox.module.scss';
import { constructAvailableMeetingRoomParam, EnmuRecurrenceRule, generateTimeRange, getSeqNo, handleMeetingFormTimeRangeNew } from './util';
import ExtraSelect from '../ExtraSelect/ExtraSelect';
import ContactEmpty from '@web-contact/component/Empty/empty';
import ContactDetail from '@web-contact/component/Detail/detail';
import { contactApi } from '@web-common/utils/contact_util';
import { getDurationText } from '../TimeLinePicker/util';
import { useAppSelector } from '@web-common/state/createStore';
import ProductAuthTag from '@web-common/components/UI/ProductAuthTag/ProductAuthTag';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { getIn18Text } from 'api';
import { TongyongCuowutishiMian } from '@sirius/icons';
const TOP_TOOL_BAR_HEIGHT = 46;
const TITLE_HEIGHT = 14 + 8;
const TAB_BAR_HEIGHT = 40 + 16;
const FOOTER_HEIGHT = 56;
const FORM_TOOL_BAR_HEIGHT = 32 + 12;
const OccupiedDetail = ({ detail, onNavigate }) => {
    const [visible, setVisible] = useState(false);
    const [contact, setContact] = useState();
    const handleVisibleChange = async (v) => {
        if (!contact && v) {
            const [aim] = await contactApi.doGetContactById(detail.user_id);
            setContact(aim);
        }
        setVisible(v);
    };
    return (React.createElement(Tooltip, { title: `已被${detail.user_name}预定` },
        React.createElement(Popover, { overlayStyle: {
                zIndex: 1090,
                paddingBottom: 2,
            }, visible: visible, trigger: ['click'], onVisibleChange: handleVisibleChange, content: React.createElement(ContactDetail, { contactId: contact === null || contact === void 0 ? void 0 : contact.contact.id, email: contactApi.doGetModelDisplayEmail(contact), onNavigate: onNavigate, dividerLine: false, branch: true, smallerAvatarSize: true, visibleSchedule: false }) },
            React.createElement("span", { style: {
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'transparent',
                } }))));
};
const RoomTimeLineCard = ({ roomInfo, children, onSelect, selected, noHover }) => {
    const { name, instruments, capacity } = roomInfo;
    const Media = selected ? MediaWhiteIcon : MediaIcon;
    return (React.createElement("div", { onClick: () => onSelect && onSelect(roomInfo), className: classNames(styles.roomCard, {
            [styles.roomCardSelected]: selected,
            [styles.roomCardNohover]: noHover,
        }) },
        React.createElement("p", { className: styles.roomName }, `${name} ${capacity.title ? `（${capacity.title}）` : ''}`),
        React.createElement("p", { className: styles.media },
            React.createElement(Media, { className: styles.mediaIcon }),
            React.createElement("span", { className: styles.mediaDesc }, (instruments === null || instruments === void 0 ? void 0 : instruments.filter(e => e.code !== '0').map(media => media.name).join(' | ')) || getIn18Text('SHEBEIWEIZHI'))),
        children));
};
const MatchedRoomGroups = ({ roomList, onOk, viewAll, duration, onBack, listHeight, enableAll }) => {
    const [selectdId, setSelectdId] = useState();
    const [formStartDate, formStartTime, formEndTime] = duration;
    const durationString = getDurationText([
        formStartDate.clone().set({
            hour: formStartTime.hours(),
            minute: formStartTime.minutes(),
        }),
        formEndTime,
    ]);
    if (roomList.length === 0) {
        return (React.createElement(ContactEmpty, { style: { padding: 100 }, text: `${durationString}暂无空闲会议室`, renderContent: () => enableAll ? (React.createElement("button", { type: "button", className: classNames(styles.primary, styles.button), style: { marginTop: 24 }, onClick: () => viewAll && viewAll() }, getIn18Text('CHAKANQUANBUHUI'))) : null }));
    }
    return (React.createElement("div", null,
        React.createElement("p", { className: styles.autoMatchTip },
            React.createElement("span", null, getIn18Text('YIWEININZIDONG')),
            React.createElement("b", null, durationString),
            React.createElement("span", null, getIn18Text('KONGXIANDEHUIYI'))),
        React.createElement(OverlayScrollbarsComponent, { className: styles.listContainer, style: { height: listHeight } },
            React.createElement("div", { className: styles.listInner },
                roomList.map(room => (React.createElement(RoomTimeLineCard, { key: room.roomInfo.room_id, roomInfo: room.roomInfo, selected: selectdId === room.roomInfo.room_id, onSelect: () => setSelectdId(room.roomInfo.room_id) }))),
                React.createElement("p", { className: styles.listBottom },
                    getIn18Text('DAODILA\n '),
                    "\u00A0 \u00A0",
                    enableAll && (React.createElement("a", { onClick: e => {
                            e.preventDefault();
                            viewAll && viewAll();
                        } }, getIn18Text('CHAKANQUANBUHUI')))))),
        React.createElement("div", { className: styles.footer },
            React.createElement(Button, { onClick: () => onBack && onBack() }, getIn18Text('QUXIAO')),
            React.createElement(Button, { style: { marginLeft: 8 }, type: "primary", disabled: !selectdId, onClick: () => {
                    const selectRoom = roomList.find(r => r.roomInfo.room_id === selectdId);
                    if (selectRoom && onOk) {
                        onOk(selectRoom);
                    }
                } }, getIn18Text('QUEDING')))));
};
const ExpandIcon = () => React.createElement(Icon, { rev: undefined, component: () => React.createElement("i", { className: `dark-invert ${styles.expandIcon}` }), style: { pointerEvents: 'none' } });
const CustomDatePicker = (_a) => {
    var props = __rest(_a, []);
    const [open, setOpen] = useState(false);
    return (React.createElement(DatePicker, Object.assign({ onClick: () => setOpen(!open), open: open, onOpenChange: v => {
            if (!v) {
                setOpen(v);
            }
        } }, props)));
};
export const MeetingRoomForm = ({ scheduleFormRef, onBack, onSelectAddr, onNavigate, defaultSelectedAddr = '', disableBackIcon = false, locationChange, style, reserveConfig, }) => {
    const [roomList, setRoomList] = useState();
    const [tabKey, setTabKey] = useState('1');
    const [roomMatchList, setRoomMatchList] = useState();
    const [searchCondition, setSearchCondition] = useState();
    const { scheduleEvent } = useAppSelector(state => state.scheduleReducer);
    const { ref, height = 380 } = useResizeDetector();
    const formIntance = scheduleFormRef === null || scheduleFormRef === void 0 ? void 0 : scheduleFormRef.getFormInstance();
    const [formStartDate, setFormStartDate] = useState(moment());
    const [formStartTime, setFormStartTime] = useState(moment());
    const [formEndDate, setFormEndDate] = useState(moment());
    const [formEndTime, setFormEndTime] = useState(moment());
    const [formStart, setFormStart] = useState();
    const [formEnd, setFormEnd] = useState();
    const [searchEnable, setSearchEnable] = useState(false);
    const [searchParams, setSearchParams] = useState({
        date: formStartDate.format('YYYY-MM-DD'),
        addr: defaultSelectedAddr,
    });
    useEffect(() => {
        const values = scheduleFormRef === null || scheduleFormRef === void 0 ? void 0 : scheduleFormRef.getFormInstance().getFieldsValue();
        if (values) {
            handleMeetingFormTimeRangeNew(Object.assign(Object.assign({}, values.moments), { allDay: !!values.time.allDay, zoneId: values.zoneId })).then(res => {
                setFormStartDate(res.formStartDate);
                setFormStartTime(res.formStartTime);
                setFormEndDate(res.formEndDate);
                setFormEndTime(res.formEndTime);
                setFormStart(res.originStart);
                setFormEnd(res.originEnd);
                setSearchParams(prev => (Object.assign(Object.assign({}, prev), { date: res.formStartDate.format('YYYY-MM-DD') })));
                setSearchEnable(true);
            });
        }
        else {
            setSearchEnable(false);
        }
    }, []);
    const handleAutoMatchOk = (info) => {
        const { roomInfo: { name, addr_name, room_id }, } = info;
        const hasDurationLimit = !!((reserveConfig === null || reserveConfig === void 0 ? void 0 : reserveConfig.maxReserveDuration) && reserveConfig.maxReserveDuration > 0);
        formIntance === null || formIntance === void 0 ? void 0 : formIntance.setFieldsValue(Object.assign(Object.assign({ location: [name, addr_name].filter(e => !!e).join('，'), moments: {
                startDate: formStartDate.clone(),
                endDate: formEndDate.clone(),
                startTime: formStartTime.clone(),
                endTime: formEndTime.clone(),
            } }, (hasDurationLimit ? { time: { allDay: 0 } } : {})), { meetingOrderParam: {
                update_type: 1,
                room_id,
                taken_date: formStartDate.format('YYYY-MM-DD'),
            } }));
        setTimeout(() => { var _a; return (_a = scheduleFormRef === null || scheduleFormRef === void 0 ? void 0 : scheduleFormRef.recomputeDurationError) === null || _a === void 0 ? void 0 : _a.call(scheduleFormRef); }, 0);
        locationChange && locationChange();
        onBack && onBack(true);
        if (!((formStart === null || formStart === void 0 ? void 0 : formStart.y) === (formEnd === null || formEnd === void 0 ? void 0 : formEnd.y) && (formStart === null || formStart === void 0 ? void 0 : formStart.m) === (formEnd === null || formEnd === void 0 ? void 0 : formEnd.m) && (formStart === null || formStart === void 0 ? void 0 : formStart.d) === (formEnd === null || formEnd === void 0 ? void 0 : formEnd.d))) {
            SiriusMessage.info({
                content: getIn18Text('crossScheduleMeetingRoomTip'),
            });
        }
    };
    useEffect(() => {
        getMeetingRoomSearchCondition().then(setSearchCondition);
    }, []);
    useEffect(() => {
        constructAvailableMeetingRoomParam(formIntance === null || formIntance === void 0 ? void 0 : formIntance.getFieldsValue(), scheduleEvent).then(condition => {
            if (condition) {
                getMeetingRoomAvailabelList(condition)
                    .then(setRoomMatchList)
                    .catch(() => setRoomMatchList([]));
            }
        });
    }, []);
    useEffect(() => {
        var _a;
        if (!searchEnable) {
            return;
        }
        getMeetingRoomList(searchParams, (_a = scheduleEvent === null || scheduleEvent === void 0 ? void 0 : scheduleEvent.scheduleInfo.meetingInfo) === null || _a === void 0 ? void 0 : _a.order_id).then(setRoomList);
    }, [searchParams, searchEnable]);
    const { enmuRecurrenceRule } = (scheduleFormRef === null || scheduleFormRef === void 0 ? void 0 : scheduleFormRef.getFormInstance().getFieldsValue()) || {};
    const enableAll = enmuRecurrenceRule === EnmuRecurrenceRule.NONE || enmuRecurrenceRule === undefined;
    return (React.createElement("div", { className: styles.body, style: style, ref: ref },
        React.createElement("div", { style: { position: 'relative', height: '100%' } },
            React.createElement(PageHeader, { className: styles.pageHeader, title: React.createElement("div", { className: styles.pageHeaderTitle },
                    React.createElement(ProductAuthTag, { tagName: ProductTagEnum.MEETING_SETTING },
                        getIn18Text('XUANZEHUIYISHI'),
                        " "),
                    !!((reserveConfig === null || reserveConfig === void 0 ? void 0 : reserveConfig.maxReserveDuration) && reserveConfig.maxReserveDuration > 0) && (React.createElement("div", { className: styles.pageHeaderTip },
                        React.createElement(TongyongCuowutishiMian, { className: styles.pageHeaderTipIcon, wrapClassName: styles.pageHeaderTipIconWrap }),
                        React.createElement("span", { className: styles.pageHeaderTipText }, getIn18Text('管理员已设置：会议室单次日程最长{minutes}分钟', { minutes: reserveConfig.maxReserveDuration }))))), backIcon: React.createElement("i", { className: styles.arrowLeft }), onBack: disableBackIcon ? undefined : () => onBack && onBack() }),
            React.createElement(Tabs, { defaultActiveKey: "1", activeKey: tabKey, onChange: setTabKey },
                React.createElement(Tabs.TabPane, { tab: getIn18Text('KEYONGHUIYISHI'), key: "1" },
                    ' ',
                    roomMatchList !== undefined && (React.createElement(MatchedRoomGroups, { enableAll: enableAll, listHeight: height - TITLE_HEIGHT - TAB_BAR_HEIGHT - TOP_TOOL_BAR_HEIGHT - FOOTER_HEIGHT, onBack: onBack, duration: [formStartDate, formStartTime, formEndTime], viewAll: () => setTabKey('2'), roomList: roomMatchList, onOk: handleAutoMatchOk }))),
                enableAll && (React.createElement(Tabs.TabPane, { tab: getIn18Text('QUANBUHUIYISHI'), key: "2" },
                    ' ',
                    React.createElement("div", { className: styles.toolbar },
                        React.createElement(CustomDatePicker, { inputReadOnly: true, format: getIn18Text('MMYUEDD12'), locale: locale, dropdownClassName: commonStyles.datePickerDropDown, style: { width: 128 }, allowClear: false, showNow: false, suffixIcon: React.createElement(ExpandIcon, null), showToday: false, defaultValue: formStartDate, className: styles.datePicker, onChange: date => {
                                if (date) {
                                    setSearchParams(prev => (Object.assign(Object.assign({}, prev), { date: date.format('YYYY-MM-DD') })));
                                }
                            } }),
                        searchCondition !== undefined && searchCondition.addr_list.filter(e => e !== '').length > 0 && (React.createElement(Select, { style: { width: 188 }, dropdownClassName: commonStyles.selectDropDown, placeholder: getIn18Text('XUANZEHUIYISHI'), suffixIcon: ExpandIcon, defaultValue: defaultSelectedAddr, options: [
                                {
                                    label: getIn18Text('QUANBUDEDIAN'),
                                    value: '',
                                },
                                ...searchCondition.addr_list
                                    .filter(e => e !== '')
                                    .slice()
                                    .reverse()
                                    .map(addr => ({
                                    label: addr,
                                    value: addr,
                                })),
                            ], onChange: value => {
                                if (onSelectAddr) {
                                    onSelectAddr(value);
                                }
                                setSearchParams(prev => (Object.assign(Object.assign({}, prev), { addr: value })));
                            } })),
                        searchCondition !== undefined && (searchCondition.capacity_list.length > 0 || searchCondition.instruments.length > 0) && (React.createElement(ExtraSelect, { suffixIcon: ExpandIcon, capacity_list: searchCondition.capacity_list, instruments: searchCondition.instruments, onChange: value => {
                                setSearchParams(prev => (Object.assign(Object.assign({}, prev), value)));
                            } }))),
                    React.createElement(OverlayScrollbarsComponent, { className: styles.listContainer, style: {
                            marginBottom: 20,
                            height: height - TOP_TOOL_BAR_HEIGHT - FORM_TOOL_BAR_HEIGHT - TAB_BAR_HEIGHT,
                        } },
                        React.createElement("div", { className: styles.listInner },
                            (roomList === null || roomList === void 0 ? void 0 : roomList.length) === 0 && React.createElement(ContactEmpty, { text: getIn18Text('ZANWUHUIYISHI'), style: { marginTop: 114 } }),
                            React.createElement(TimeLinePickerGroup, null, roomList === null || roomList === void 0 ? void 0 : roomList.map(room => {
                                const { room_id, addr_name, name, occupy_list, roomBookInfoVO: { time_axis, start, end, interval }, } = room;
                                const _interval = interval;
                                const date = moment(searchParams.date);
                                const timeRanges = generateTimeRange(time_axis, start, _interval, date);
                                const occupied = timeRanges.filter(e => e.occupied).map(e => e.range);
                                const forbidden = timeRanges.filter(e => e.expired).map(e => e.range);
                                return (React.createElement(RoomTimeLineCard, { noHover: true, roomInfo: room, key: room_id },
                                    React.createElement(TimeLinePicker, { date: date, forbidden: forbidden, startHour: start, endHour: end, pieceOfHour: 1 / _interval, occupied: occupied, renderForbiddenInner: () => (React.createElement(Tooltip, { title: getIn18Text('YIGUOQI') },
                                            React.createElement("span", { style: {
                                                    display: 'block',
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    right: 0,
                                                    bottom: 0,
                                                    backgroundColor: 'transparent',
                                                } }))), renderEnableInner: () => (React.createElement(Tooltip, { title: getIn18Text('KEXUANZE') },
                                            ' ',
                                            React.createElement("span", { style: {
                                                    display: 'block',
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    right: 0,
                                                    bottom: 0,
                                                    backgroundColor: 'transparent',
                                                } }))), renderOccupiedInner: range => {
                                            const [_start] = range;
                                            const startSeq = getSeqNo(_start, _interval);
                                            const detail = occupy_list === null || occupy_list === void 0 ? void 0 : occupy_list.find(e => e.seq_no === startSeq);
                                            if (detail === undefined) {
                                                return null;
                                            }
                                            return React.createElement(OccupiedDetail, { onNavigate: onNavigate, detail: detail });
                                        }, onOk: value => {
                                            const [startMoment, endMoment] = value;
                                            const hasDurationLimit = !!((reserveConfig === null || reserveConfig === void 0 ? void 0 : reserveConfig.maxReserveDuration) && reserveConfig.maxReserveDuration > 0);
                                            const allDay = (!hasDurationLimit && startMoment.hours() === start && endMoment.hours() === end);
                                            formIntance === null || formIntance === void 0 ? void 0 : formIntance.setFieldsValue({
                                                moments: {
                                                    startDate: startMoment,
                                                    endDate: endMoment,
                                                    startTime: startMoment.clone(),
                                                    endTime: endMoment.clone(),
                                                },
                                                time: {
                                                    allDay,
                                                },
                                                location: [name, addr_name].filter(e => !!e).join('，'),
                                                meetingOrderParam: {
                                                    room_id,
                                                    taken_date: searchParams.date,
                                                    update_type: 1,
                                                },
                                            });
                                            setTimeout(() => { var _a; return (_a = scheduleFormRef === null || scheduleFormRef === void 0 ? void 0 : scheduleFormRef.recomputeDurationError) === null || _a === void 0 ? void 0 : _a.call(scheduleFormRef); }, 0);
                                            locationChange && locationChange();
                                            onBack && onBack(true);
                                        } })));
                            }))))))))));
};
